// extracted by mini-css-extract-plugin
module.exports = {"inactiveProduct":"PixInactiveAlert_inactiveProduct__3SwUd"};